import { InboxOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  Button,
  GetProp,
  Modal,
  Spin,
  Upload,
  UploadFile,
  UploadProps,
} from "antd";
import { useState } from "react";
import toast from "react-hot-toast";
import Api, { ApiResponse } from "../../utils/axios";

const { Dragger } = Upload;
type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

const UploadClientsCsv = () => {
  const [modal, setModal] = useState(false);
  const [file, setFile] = useState<UploadFile[]>([]);
  const [validating, setValidating] = useState(false);
  const [uploading, setUploading] = useState(false);

  //   const validate = () => {
  //     setValidating(true);

  //     CSVFileValidator(file[0].name, {
  //       headers: [
  //         {
  //           name: "name",
  //           inputName: "name",
  //           required: true,
  //           requiredError: function (headerName, rowNumber, columnNumber) {
  //             return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`;
  //           },
  //         },
  //         {
  //           name: "phone",
  //           inputName: "phone",
  //           required: true,
  //           unique: true,
  //           uniqueError: function (headerName) {
  //             return `${headerName} is not unique`;
  //           },
  //           requiredError: function (headerName, rowNumber, columnNumber) {
  //             return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`;
  //           },
  //         },
  //         {
  //           name: "dob",
  //           inputName: "dob",
  //           required: true,
  //           requiredError: function (headerName, rowNumber, columnNumber) {
  //             return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`;
  //           },
  //         },
  //         {
  //           name: "gender",
  //           inputName: "gender",
  //           required: true,
  //           requiredError: function (headerName, rowNumber, columnNumber) {
  //             return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`;
  //           },
  //         },
  //         {
  //           name: "storeId",
  //           inputName: "storeId",
  //           required: true,
  //           requiredError: function (headerName, rowNumber, columnNumber) {
  //             return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`;
  //           },
  //         },
  //       ],
  //     })
  //       .then((csvData) => {
  //
  //         // csvData.data; // Array of objects from file
  //         // csvData.inValidData; // Array of error messages
  //       })
  //       .catch((err) => {
  //
  //       });

  //     setValidating(false);
  //   };

  const handleUpload = async () => {
    // validate();
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file[0] as FileType);
    // You can use any AJAX library you like
    const res = (await Api.post("/customers/upload-csv", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })) as ApiResponse<any>;
    if (res.success) {
      toast.success("Upload successful");
      setFile([]);
      closeModal();
    }
    setUploading(false);
  };

  const props: UploadProps = {
    multiple: false,
    onRemove: () => {
      setFile([]);
    },
    beforeUpload: (file) => {
      setFile([file]);

      return false;
    },
    fileList: file,
    disabled: uploading,
    accept: ".csv",
  };

  const openModal = () => {
    setModal(true);
  };

  const closeModal = () => {
    if (!uploading) {
      setModal(false);
    }
  };

  return (
    <div>
      <Button onClick={openModal}>Upload CSV</Button>
      <Modal
        open={modal}
        centered
        closable
        onCancel={closeModal}
        title="Upload CSV"
        onOk={handleUpload}
        okText="Upload"
      >
        <div className="mt-5">
          <Dragger {...props}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">
              Support for a single or bulk upload. Strictly prohibited from
              uploading company data or other banned files.
            </p>
          </Dragger>
        </div>
        {uploading && (
          <div className="mt-3">
            Uploading, Please wait{" "}
            <Spin
              indicator={<LoadingOutlined spin />}
              size="small"
              className="ml-3"
            />
          </div>
        )}
      </Modal>
    </div>
  );
};

export default UploadClientsCsv;
